import '../assets/css/howmany.css';

import React, { useState } from 'react';

export const Howmany = ({ FromHowMany , ToMax }) => {
  const [quantity, setQuantity] = useState(1);
  const handleSubmit = () => {
    FromHowMany(quantity);
  };
  return (
    <div className="howmany">
      <label>How many do you want to mint? </label>
      <div className="row">
        <div className="col">
          <input
            className="form-control quantity"
            type="number"
            step=""
            min="1"
            max={ToMax}
            defaultValue="1"
            onChange={(e) => setQuantity(e.target.value)}
          ></input>
        </div>
        <div className="col">
          <button type="submit" className="btn btn-primary" onClick={() => handleSubmit()}>
            Alright, let's do it! 
          </button>
        </div>
      </div>
    </div>
  );
};
